import { SupportEmail } from "../emailTypes"

export const selectedEmailsToApi = (emails?: SupportEmail[]) => {
    return emails?.map((email) => ({
        id: email.id,
        receiver: {
            ...email.receiver,
        },
    }))
}
